module.exports = __webpack_public_path__ + "static/img/Nicolas.b990146.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Nicolas.png
// module id = dm5Q
// module chunks = 1